import { render, staticRenderFns } from "./m-batch-history-item.vue?vue&type=template&id=8e60bc6e&scoped=true&"
import script from "./m-batch-history-item.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-batch-history-item.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-batch-history-item.vue?vue&type=style&index=0&id=8e60bc6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e60bc6e",
  null
  
)

export default component.exports